import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useCore } from "../hooks";
import './SideNavigation.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getDepotoLogoSrc, isStageEnvironment, STAGE_SERVER_TOOLTIP } from '../utils'

export const SideNavigation: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { checkouts, selectedCheckoutId, core } = useCore()
  const clientType = core?.services?.oauth?.session?.clientType ?? window.depotoEnv
  const depotoLogo = getDepotoLogoSrc('nav', clientType)
  const isStageLogo = isStageEnvironment(clientType)

  const dashboardPartPaths = ['/dashboard', '/checkout-select', '/checkout-open', '/preview-reservation', '/preview-bill']
  // const isOnDashboardPart = dashboardPartPaths.includes(location.pathname)
  const isOnDashboardPart = dashboardPartPaths.find(p => location.pathname?.includes(p))
  const checkoutsPartPaths = ['/checkout-detail']
  const isOnCheckoutsPart = checkoutsPartPaths.find(p => location.pathname?.includes(p))
  const customersPartPaths = ['/customer-list']
  const isOnCustomersPart = customersPartPaths.find(p => location.pathname?.includes(p))
  const settingsPartPaths = ['/settings']
  const isOnSettingsPart = settingsPartPaths.find(p => location.pathname?.includes(p))

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else {
      document.documentElement.requestFullscreen()
    }
  }

  return (
    <nav className="side-navigation">
      <div
        className={`side-navigation-logo ${isStageLogo ? 'tooltip tooltip-right' : ''}`}
        data-tip={isStageLogo ? STAGE_SERVER_TOOLTIP : undefined}
      >
        <img
          src={depotoLogo}
          alt="Depoto Logo"
          className={`object-contain ${isStageLogo ? 'depoto-logo--stage' : ''}`}
        />
      </div>
      <div className={`side-navigation-item ${isOnDashboardPart ? 'active' : ''}`} onClick={() => navigate('/dashboard')}>
        <FontAwesomeIcon icon={['far', 'cash-register']} />
      </div>
      <div className={`side-navigation-item ${isOnCheckoutsPart ? 'active' : ''}`} onClick={() => navigate('/checkout-detail')}>
        <FontAwesomeIcon icon={['far', 'receipt']} />
      </div>
      <div className={`side-navigation-item ${isOnCustomersPart ? 'active' : ''}`} onClick={() => navigate('/customer-list')}>
        <FontAwesomeIcon icon={['far', 'users']} />
      </div>
      <div className="side-navigation-bottom-items">
        <div className={`side-navigation-item ${isOnSettingsPart ? 'active' : ''}`}
          onClick={() => navigate('/settings')}>
          <FontAwesomeIcon icon={['far', 'cog']} />
        </div>
        <div className="side-navigation-item"
          onClick={toggleFullscreen}>
          <FontAwesomeIcon icon={['far', 'arrows-maximize']} />
        </div>
      </div>
    </nav>
  )
}
